/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AttachmentSaveLocationType } from './attachment-save-location-type.enum';

export class AttachmentVO {

  uuid: string | undefined = undefined ;
  fileStoreAttachmentUuid: string | undefined = undefined;
  fileName: string | undefined = undefined;
  fileType: string | undefined = undefined;
  fileSizeKB: number | undefined = undefined;
  officialDocument?: boolean;
  attachmentSaveLocation?: AttachmentSaveLocationType;

  constructor(
    fileStoreAttachmentUuid: string | undefined,
    fileName: string | undefined,
    fileType: string | undefined,
    fileSizeKB: number | undefined
  ) {
    this.fileName = fileName;
    this.fileType = fileType;
    this.fileStoreAttachmentUuid = fileStoreAttachmentUuid;
    this.fileSizeKB = fileSizeKB;
  }
}
